import React, { PropTypes } from 'react'

import Swipe from 'react-easy-swipe';


class WorkCarousel extends React.Component {


  constructor(props){

    super();

    //console.log("carousel",props);

    this.state = {
      activeSlide: 0,
      prevSlide: 0,
      animationDir:'',
      totalSlides: props.images.length
    }

    this.nextSlide = this.nextSlide.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
    this.gotoSlide = this.gotoSlide.bind(this);

  }

  nextSlide(){


    let activeSlide = this.state.activeSlide + 1;
    let prevSlide = this.state.activeSlide;
    let animationDir = 'asc';

    (activeSlide>=this.state.totalSlides)?
      activeSlide = 0
    : null ;

    this.setState({activeSlide,prevSlide,animationDir})

  }

  prevSlide(){

    let activeSlide = this.state.activeSlide -1;
    let prevSlide = this.state.activeSlide;
    let animationDir = 'desc';

    (activeSlide<0)?
      activeSlide = this.state.totalSlides-1
    : null ;

    this.setState({activeSlide,prevSlide,animationDir})

  }

  gotoSlide(activeSlide){
          this.setState({activeSlide})
  }

  render () {


      if(!this.props.images){
        return null;
      }

      // check for gui color
      let guiClass = (window.innerWidth < 769)?  this.props.images[this.state.activeSlide].slide_options.mobile_gui_colour : this.props.images[this.state.activeSlide].slide_options.gui_colour;






      return(
        <div>
        <Swipe allowMouseEvents
           onSwipeLeft={this.nextSlide}
           onSwipeRight={this.prevSlide}
           
           >
        <div className={"work-carousel "+(this.props.className+" ")+(this.state.animationDir)+' '+(guiClass)}>
          {
            this.props.images.map((item,index) =>{

                  let slideClass = "slide";

                  (this.state.activeSlide===index)?
                    slideClass+= " active"
                  :(this.state.prevSlide===index)?
                    slideClass+=" prev"
                  : null;


                  return (<div key={'slide'+index} className={slideClass}>
                            <Slide {...item} src={item.image.url} />
                        </div>)
            })

          }
          <div className="controls">
            <div className="next" onClick={this.nextSlide} />
            <div className="prev" onClick={this.prevSlide}  />
            <div className="indicators">
              {
                this.props.images.map((item,index) =>{
                    return (<div key={'ind'+index} className={'indicator '+((this.state.activeSlide===index)? 'active' : '')} onClick={()=>this.gotoSlide(index)}><div className="inner"></div></div>)
                })
              }
            </div>
          </div>
        </div>
      </Swipe>
      </div>
      )
  }
}

const Slide = (props) =>{

  //console.log("SLIDE",props);

  // Swap mobile if it's iPad portrait or less
  let layout = (window.innerWidth < 769)? props.slide_options.layout_mobile : props.slide_options.layout  ;

  let imageUrl = (window.innerWidth < 769 && props.image_mobile.url )? props.image_mobile.url : props.image.url  ;

  //console.log( (window.innerWidth < 769),props.slide_options.layout_mobile : props.slide_options.layout);

  // if no mobile image and we're on mobile
    if(window.innerWidth < 769 && !props.image_mobile.url){
      imageUrl =  props.image.sizes.medium_large;
    }

  return(

      <div>
        {(layout==='cover')?
            <div className="cover" style={{backgroundImage:`url(${imageUrl})`}} />
        :(layout ==='with_margin')?
          <div className="cover-with-margin" >
              <div style={{backgroundImage:`url(${imageUrl})`}} />
          </div>
        :(layout ==='centred')?
          <img className="centred" src={imageUrl} alt="" />
        : null
        }
        <div className="caption" >
          <div className="inner" dangerouslySetInnerHTML={{__html:props.slide_options.caption}} />
        </div>
     </div>
  )

}

export default WorkCarousel;



// WEBPACK FOOTER //
// ./src/modules/work/WorkCarousel.js